// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Button } from 'react-bootstrap';
import axios from 'axios';

// import modules
import DefaultContainer from '../../modules/Containers/DefaultContainer';
import DefaultPageTitle from '../../modules/Containers/DefaultPageTitle';
import ShowMessages from '../../modules/ShowMessages/ShowMessages';

// load config
import Config from '../../config/config';

export default function PageContacts() {
    const { t } = useTranslation('contacts', { keyPrefix: 'contacts' });
    const emailservicetoken = Config.contacts.emailservicetoken;

    const [validated, setValidated] = useState(false);
    const [sent, setSent] = useState(false);
    const [senderror, setSenderror] = useState(null);

    // handle submit
    const handleSubmit = (event) => {
        // get form
        const form = event.currentTarget;
        // prevent default actions
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() !== false) {
            try {
                axios.post('emailservice.php', {
                    from: form['form_name'].value,
                    email: form['form_email'].value,
                    message: form['form_message'].value,
                    emailservicetoken
                })
                    .then(() => {
                        // form is sent
                        setSent(true);
                    }, () => {
                        // sending error happens
                        setSenderror(t('error_message'));
                    });
            }
            catch {
                setSenderror(t('error_message'));
            }
        }

        // set as validated
        setValidated(true);
    };

    return (
        <DefaultContainer>
            <DefaultPageTitle>{t('title')}</DefaultPageTitle>
            {sent ?
                <>
                    <p style={{ color: 'var(--bs-success)' }}> {t('mail_sent')}</p>
                </>
                : <>
                    {senderror != null ?
                        <ShowMessages title={t('error_title')} messages={[senderror.toString()]} mode='E' onClose={() => { setSenderror(null); }} />
                        : null}
                    <p>{t('filltext')}</p>
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="form_email">
                            <Form.Label>{t('email_label')}</Form.Label>
                            <Form.Control type="email" placeholder={t('email_placeholder')} required />
                            <Form.Text className="text-muted"> {t('email_info')} </Form.Text>
                            <Form.Control.Feedback type="invalid"> {t('email_invalid')} </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="form_name">
                            <Form.Label>{t('name_label')}</Form.Label>
                            <Form.Control type="text" placeholder={t('name_placeholder')} required />
                            <Form.Control.Feedback type="invalid">{t('name_invalid')}</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="form_message">
                            <Form.Label>{t('message_label')}</Form.Label>
                            <Form.Control as="textarea" placeholder={t('message_placeholder')} required />
                            <Form.Control.Feedback type="invalid">{t('message_invalid')}</Form.Control.Feedback>
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            {t('button_submit')}
                        </Button>
                    </Form>
                </>
            }
        </DefaultContainer>
    );
}
